import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Change Request API functions
const getAllChangeRequests = async (params = {}) => {
  try {
    const response = await api.get('/change-requests', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching change requests:', error);
    throw error;
  }
};

const getChangeRequestById = async (id) => {
  try {
    const response = await api.get(`/change-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching change request:', error);
    throw error;
  }
};

const createChangeRequest = async (data) => {
  try {
    const response = await api.post('/change-requests', data);
    return response.data;
  } catch (error) {
    console.error('Error creating change request:', error);
    throw error;
  }
};

const updateChangeRequest = async (id, data) => {
  try {
    const response = await api.put(`/change-requests/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating change request:', error);
    throw error;
  }
};

const deleteChangeRequest = async (id) => {
  try {
    const response = await api.delete(`/change-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting change request:', error);
    throw error;
  }
};

const approveChangeRequest = async (id, approvalComments = '') => {
  try {
    const response = await api.post(`/change-requests/${id}/approve`, { approvalComments });
    return response.data;
  } catch (error) {
    console.error('Error approving change request:', error);
    throw error;
  }
};

const rejectChangeRequest = async (id, approvalComments = '') => {
  try {
    const response = await api.post(`/change-requests/${id}/reject`, { approvalComments });
    return response.data;
  } catch (error) {
    console.error('Error rejecting change request:', error);
    throw error;
  }
};

const getChangeRequestStats = async () => {
  try {
    const response = await api.get('/change-requests/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching change request stats:', error);
    throw error;
  }
};

const changeRequestService = {
  getAllChangeRequests,
  getChangeRequestById,
  createChangeRequest,
  updateChangeRequest,
  deleteChangeRequest,
  approveChangeRequest,
  rejectChangeRequest,
  getChangeRequestStats
};

export default changeRequestService;

